export default __webpack_public_path__ + "assets/images/eec677aa634468df2b6b3dcaba3d5b29.png";